import React from 'react';
import { bool, array, object } from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from '@fiverr-private/fiverr_context';
import RecommendedBadge from '../../shared/RecommendedBadge';
import TranslatedBadge from '../../shared/TranslatedBadge';
import { getPackageTypeById } from '../../../utils/packagesUtils';
import { isTranslated } from '../../../utils/ugc/isTranslated';
import ServiceFeeIcon from '../ServiceFeeIcon';

import './style.scss';

const PackageType = ({ packageList, showTranslatedBadge = false, showServiceFeeIcon = false }, { currencyConverter }) => (
    <tr className="package-type">
        <th>
            <I18n k={'gig_page_perseus.packages_table.package'}/>
            {showTranslatedBadge && <TranslatedBadge/>}
        </th>
        {
            packageList.map((packageData) => {
                const { id, recommendedType } = packageData;

                return (
                    <td key={id}>
                        {recommendedType &&
                        <RecommendedBadge recommendedType={recommendedType}
                            tooltipPosition={RecommendedBadge.POSITIONS.BOTTOM}/>
                        }
                        <div className="price-wrapper">
                            <p className="price">{currencyConverter.convertWithFee(packageData.currentPrice)}</p>
                            { showServiceFeeIcon && <ServiceFeeIcon packageId={id}/> }
                        </div>
                        <b className="type"><I18n k={getPackageTypeById(id)}/></b>
                        <b className="title">{packageData.title}</b>
                    </td>
                );
            })
        }
    </tr>
);

const mapStateToProps = ({ packages, ugc }) => ({
    packageList: packages.packageList,
    showTranslatedBadge: isTranslated(ugc)
});

PackageType.propTypes = {
    packageList: array,
    showTranslatedBadge: bool,
    showServiceFeeIcon: bool
};

PackageType.contextTypes = {
    currencyConverter: object
};

export { PackageType };
export default connect(mapStateToProps)(PackageType);
